<template>
  <li>
    <router-link :to="{ name }" :class="{ 'current-page': isCurrentPage}">
      {{ label }}
    </router-link>
  </li>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    isCurrentPage() {
      return this.$route.name === this.name;
    },
  },
});
</script>

<style scoped lang="scss">
.current-page {
  border-left: 0.3em solid #662c91;
  padding-left: 0.5em;
  margin-left: -0.8em;
}
</style>
